"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HighlightPopover;
var _react = _interopRequireWildcard(require("react"));
var _icons = require("@material-ui/icons");
var _NoteAdd = _interopRequireDefault(require("@material-ui/icons/NoteAdd"));
var _core = require("@material-ui/core");
var _styles = _interopRequireDefault(require("./styles"));
var _Highlight = require("../../constants/Highlight");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _Highlight2 = _interopRequireDefault(require("../../api/Highlight"));
var _Auth = require("../../contexts/Auth");
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function HighlightPopover(props) {
  var {
    highlight,
    setHighlight,
    handleCopyButtonClick
  } = props;
  var classes = (0, _styles.default)();
  var [popoverHeight, setPopoverHeight] = (0, _react.useState)();
  var {
    auth
  } = (0, _Auth.useAuth)();
  var {
    applicationToken,
    sessionToken,
    uuid,
    userId,
    bookTitle
  } = auth;
  var tracking = (0, _Trackings.default)(auth);
  var [onHashChangeCallback, setOnHashChangeCallback] = (0, _react.useState)();
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  var HASH = 'popover';
  (0, _react.useEffect)(() => {
    function onHashChange() {
      if (onHashChangeCallback) {
        onHashChangeCallback();
        setOnHashChangeCallback();
      }
    }
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [onHashChangeCallback]);
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        setHighlight();
        window.getSelection().removeAllRanges();
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, setHighlight]);
  (0, _react.useEffect)(() => {
    if (highlight) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [highlight]);
  function onClose() {
    setHighlight();
    window.getSelection().removeAllRanges();
  }
  function isPopoverOnFooter() {
    var _highlight$text_refer;
    return (highlight === null || highlight === void 0 || (_highlight$text_refer = highlight.text_reference) === null || _highlight$text_refer === void 0 || (_highlight$text_refer = _highlight$text_refer.endEl) === null || _highlight$text_refer === void 0 || (_highlight$text_refer = _highlight$text_refer.getBoundingClientRect()) === null || _highlight$text_refer === void 0 ? void 0 : _highlight$text_refer.bottom) + popoverHeight > window.innerHeight;
  }
  function getAnchorEl() {
    var _highlight$text_refer2, _highlight$text_refer3;
    return isPopoverOnFooter() ? highlight === null || highlight === void 0 || (_highlight$text_refer2 = highlight.text_reference) === null || _highlight$text_refer2 === void 0 ? void 0 : _highlight$text_refer2.startEl : highlight === null || highlight === void 0 || (_highlight$text_refer3 = highlight.text_reference) === null || _highlight$text_refer3 === void 0 ? void 0 : _highlight$text_refer3.endEl;
  }
  function getAnchorOrigin() {
    return {
      vertical: isPopoverOnFooter() ? 'top' : 'bottom',
      horizontal: 'center'
    };
  }
  function getTransformOrigin() {
    return {
      vertical: isPopoverOnFooter() ? 'bottom' : 'top',
      horizontal: 'center'
    };
  }
  function onPopoverRef(el) {
    setPopoverHeight(el.querySelector('.MuiPopover-paper').clientHeight);
  }
  function onClickColor(color) {
    if (highlight.color === color.id) {
      onDelete(highlight);
    } else if (highlight.id) {
      onUpdate(_objectSpread(_objectSpread({}, highlight), {}, {
        color: color.id
      }));
    } else {
      onInsert(_objectSpread(_objectSpread({}, highlight), {}, {
        color: color.id
      }));
    }
  }
  function onDelete(_x) {
    return _onDelete.apply(this, arguments);
  }
  function _onDelete() {
    _onDelete = _asyncToGenerator(function* (highlight) {
      _Highlight2.default.remove(applicationToken, sessionToken, highlight.id);
      props.onDelete(highlight);
      onClose();
    });
    return _onDelete.apply(this, arguments);
  }
  function onUpdate(_x2) {
    return _onUpdate.apply(this, arguments);
  }
  function _onUpdate() {
    _onUpdate = _asyncToGenerator(function* (highlight) {
      var payload = {
        color: highlight.color
      };
      var data = yield _Highlight2.default.update(applicationToken, sessionToken, highlight.id, payload);
      var newHighlight = _objectSpread(_objectSpread({}, data), highlight);
      setHighlight(newHighlight);
      props.onUpdate(newHighlight);
      tracking.trackColorHighlightEdit({
        uuid,
        titleCover: bookTitle,
        color: newHighlight.color,
        id: newHighlight.id,
        highlight: newHighlight.text_highlighted
      });
    });
    return _onUpdate.apply(this, arguments);
  }
  function onInsert(_x3) {
    return _onInsert.apply(this, arguments);
  }
  function _onInsert() {
    _onInsert = _asyncToGenerator(function* (highlight) {
      var payload = _objectSpread(_objectSpread({}, highlight), {}, {
        book_id: uuid,
        text_highlighted: highlight.text_reference.content.text,
        user_id: userId
      });
      var data = yield _Highlight2.default.create(applicationToken, sessionToken, payload);
      var newHighlight = _objectSpread(_objectSpread({}, data), highlight);
      setHighlight(newHighlight);
      props.onInsert(newHighlight);
      tracking.trackColorHighlight({
        uuid,
        titleCover: bookTitle,
        color: newHighlight.color,
        id: newHighlight.id,
        highlight: newHighlight.text_highlighted.toString()
      });
    });
    return _onInsert.apply(this, arguments);
  }
  function onAddNote() {
    props.onAddNote(highlight);
    setHighlight();
  }
  function onCopy() {
    setHighlight();
    setTimeout(() => {
      handleCopyButtonClick(highlight);
    }, 200);
  }
  return /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: Boolean(highlight),
    onClose: onClose,
    anchorEl: getAnchorEl(),
    anchorOrigin: getAnchorOrigin(),
    transformOrigin: getTransformOrigin(),
    classes: {
      paper: classes.rootPopover
    },
    ref: el => el && onPopoverRef(el)
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.popoverTitle,
    variant: "h6",
    color: "textSecondary"
  }, "Op\xE7\xF5es", /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.popoverClose,
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseSharp, null))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.popoverActions
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.btn,
    onClick: () => onCopy()
  }, /*#__PURE__*/_react.default.createElement(_icons.FileCopy, {
    className: classes.icon
  }), "Copiar"), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.btn,
    disabled: !(highlight !== null && highlight !== void 0 && highlight.color),
    onClick: onAddNote
  }, /*#__PURE__*/_react.default.createElement(_NoteAdd.default, {
    className: classes.icon
  }), "Adicionar nota")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.popoverText,
    color: "textPrimary"
  }, "Cor do Destaque"), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.noteColor
  }, Object.values(_Highlight.COLOR).map((item, index) => /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
    key: index,
    label: item.label,
    backgroundColor: item.hex,
    onClick: () => onClickColor(item),
    selected: (highlight === null || highlight === void 0 ? void 0 : highlight.color) === item.id
  }))));
}